import { applyMiddleware, createStore, combineReducers } from 'redux'

import allReducers from '../reducers'

const reducers = combineReducers(allReducers)

const middleware = []

export default initialState => createStore(reducers, initialState, applyMiddleware(...middleware))
